import { useState } from "react";

const features = [
  {
    icon: "ri-time-line",
    color: "bg-primary-500",
    title: "Urgencias 24/48h",
    text: "Servicio exprés en 24-48 horas. El mismo día en Málaga ciudad. Respuesta inmediata para averías urgentes en persianas.",
  },
  {
    icon: "ri-price-tag-3-line",
    color: "bg-accent-500",
    title: "Presupuesto gratis",
    text: "Diagnóstico sin compromiso. Precio cerrado antes de empezar. Sin sorpresas, sin costes ocultos. Transparencia total en cada servicio.",
  },
  {
    icon: "ri-shield-check-line",
    color: "bg-secondary-500",
    title: "2 años de garantía",
    text: "Todas las reparaciones e instalaciones cuentan con garantía completa de 2 años en piezas y mano de obra. Tu tranquilidad es lo primero.",
  },
  {
    icon: "ri-map-pin-line",
    color: "bg-primary-500",
    title: "Sin coste de desplazamiento",
    text: "No cobramos desplazamiento en ningún barrio de Málaga capital. Vamos a los 16 barrios sin coste extra. Desde Soliva hasta El Palo.",
  },
  {
    icon: "ri-team-line",
    color: "bg-accent-500",
    title: "Técnicos propios",
    text: "Sin subcontratas. Todos nuestros técnicos son personal en plantilla, formados y con amplia experiencia en reparación de persianas en Málaga.",
  },
  {
    icon: "ri-award-line",
    color: "bg-secondary-500",
    title: "Marcas originales",
    text: "Trabajamos con Somfy, Nice, Bubendorff y todas las marcas líderes. Recambios originales garantizados para cualquier tipo de persiana.",
  },
];

const MOBILE_VISIBLE = 3;

export default function WhyChooseSection() {
  const [expanded, setExpanded] = useState(false);
  const visibleFeatures = expanded ? features : features.slice(0, MOBILE_VISIBLE);
  const hasMore = features.length > MOBILE_VISIBLE;

  return (
    <section className="py-10 md:py-20 bg-gradient-to-br from-background-50 via-primary-50/20 to-accent-50/20">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3 font-heading">
            ¿Por qué elegirnos en Málaga?
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            Lo que nos diferencia del resto de servicios de persianas
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6">
          {visibleFeatures.map((f) => (
            <div
              key={f.title}
              className="flex items-start gap-3 md:gap-4 p-4 md:p-6 bg-background-100 rounded-2xl border border-background-200/60 hover:border-primary-300/60 transition-all hover:-translate-y-0.5"
            >
              <div className={`w-9 h-9 md:w-11 md:h-11 flex items-center justify-center rounded-xl ${f.color} text-white flex-shrink-0`}>
                <span className="w-4 h-4 md:w-5 md:h-5 flex items-center justify-center"><i className={`${f.icon} text-base md:text-xl`}></i></span>
              </div>
              <div>
                <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-1">{f.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{f.text}</p>
              </div>
            </div>
          ))}
        </div>

        {hasMore && (
          <div className="mt-4 text-center">
            <button
              onClick={() => setExpanded(!expanded)}
              className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 hover:bg-background-200 text-foreground-700 font-semibold text-sm rounded-full border border-background-200 transition-all cursor-pointer"
            >
              {expanded ? (
                <>Ver menos <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-up-s-line"></i></span></>
              ) : (
                <>Ver todas las {features.length} ventajas <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-down-s-line"></i></span></>
              )}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}